module.exports = __webpack_public_path__ + "static/media/proposal-accept.0d344fe5.svg";